import axios from 'axios'
// 创建 axios 实例
const requests = axios.create({
  baseURL: "https://admin.cqxdzx.com/addons/upmarket/index/", // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
  timeout: 5000 // 请求超时时间
})

// 错误处理函数
const err = (error) => {
  console.log(error);
  console.log('提交失败')
  return Promise.reject(error)
}

export default {
  requests
}



// WEBPACK FOOTER //
// ./src/util/mapi.js